// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Sidebar_Lazy$Showside from "./Sidebar_Lazy.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
function useSidebarTopOffset(param) {
  var offsetForStickyElements = StickyHeaderOffsetProvider$Showside.useEffective(undefined);
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = ListPageLayoutController$Showside.Context.use(undefined);
  var match$2 = match$1.state;
  var secondaryNavbarHeight = match$2.secondaryNavbarHeight;
  var effectiveTotalHeight = match$2.showPrimaryNavbar ? match$2.primaryNavbarHeight + secondaryNavbarHeight | 0 : secondaryNavbarHeight;
  return effectiveTotalHeight + (match.embedType === /* Inline */1 ? offsetForStickyElements : 0) | 0;
}
function ListPageSidebarWrapper(Props) {
  var category = Props.category;
  var appliedFilters = Props.appliedFilters;
  var appliedSort = Props.appliedSort;
  var shouldShowSidebar = Props.shouldShowSidebar;
  var isSidebarOpen = Props.isSidebarOpen;
  var topLevelCategories = Props.topLevelCategories;
  var onCategoryClick = Props.onCategoryClick;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  EntrypointContext$Showside.use(undefined);
  var match$1 = ViewportContext$Showside.use(undefined);
  var offset = useSidebarTopOffset(undefined);
  return React.createElement(ConditionalRender$Showside.When.make, {
    condition: isSidebarOpen && shouldShowSidebar,
    children: React.createElement(ErrorBoundary$Showside.make, {
      componentName: "Sidebar",
      children: React.createElement(Sidebar_Lazy$Showside.make, {
        settings: settings,
        category: category,
        appliedFilters: appliedFilters,
        appliedSort: appliedSort,
        topLevelCategories: topLevelCategories,
        margin: offset,
        height: match$1.windowSize.height - offset | 0,
        openLinkInNewTab: settings.openLinkInNewTab,
        show: true,
        onItemClick: onCategoryClick
      })
    })
  });
}
ListPageSidebarWrapper.displayName = "ListPageSidebarWrapper";
var make = ListPageSidebarWrapper;
export { useSidebarTopOffset, make };
/* react Not a pure module */